import React from 'react';
import withIcon from '../utilities/withIcon';

const IconImage = () => {
  return (
    <g>
      <path d="M15 0a1 1 0 0 1 1 1v11.939l.03.03L16 13V15a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h14zM5.5 9.061l-4 3.999v1.44h13v-.939l-3.056-3.056-1.975 1.58a.75.75 0 0 1-.914.019l-.085-.074L5.5 9.061zm9-7.561h-13v9.438L4.97 7.47a.75.75 0 0 1 .976-.073l.084.073 3.025 3.024 1.976-1.58a.75.75 0 0 1 .914-.018l.085.074 2.47 2.469V1.5zm-5 2a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5zm0 1.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2z" />
    </g>
  );
};

export default withIcon(IconImage);
